










import { Component, Vue, Watch } from "vue-property-decorator";
import { getters } from "@/observables";
@Component({})
export default class extends Vue {
  /* Computed */
  get connected() {
    return getters.getConnection();
  }

  get color() {
    return this.connected ? "success" : "orange lighten-1";
  }

  @Watch("connected") onConnected() {
    this.connected ? this.hide() : this.show();
  }

  /* Data */
  props = {
    timeout: -1
  };
  visible = false;

  /* Methods */
  hide() {
    // tempo antes de fechar que informa que a conexão foi restabelecida
    setTimeout(() => (this.visible = false), 2000);
  }

  show() {
    this.visible = true;
  }
}
